import { subselect } from './root';

const needAuthenticationSelector = ({ routesMap }) => (type) => (routesMap[type] || {}).auth;

export const locationNeedAuthenticationSelector = subselect(needAuthenticationSelector);
